import React from 'react';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

const TasksMenu = ({ anchorEl, open, handleClick, onClose }) =>
  <Menu
     id="simple-menu"
     anchorEl={anchorEl}
     open={open}
     onClose={onClose}
   >
     <MenuItem onClick={() => {
         handleClick({
           task: {type: "estimate"},
         })
     }}>
       Estimate
     </MenuItem>
     <MenuItem onClick={() => {
       handleClick({
         task: {type: "maintenance"},
       })
     }}>
       Maintenance
     </MenuItem>
     <MenuItem onClick={() => {
       handleClick({
         task: {type: "quote"},
       })
     }}>
       Quote
     </MenuItem>
   </Menu>

export default TasksMenu;



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Actions/Menus/TasksMenu.jsx